import { InspectionValues } from '../../constants/index.js';
import Traveler from './traveler.js';

function travelerFromFirestore(doc) {
  const docData = { id: doc.id, ...doc.data() };
  try {
    return Traveler.fromFirestore(docData);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error transforming traveler data:', docData.id, error);
    const InvalidDocData = { validation: 'failed', ...docData };
    return InvalidDocData;
  }
}

function travelerToFirestore(traveler, serverTimestamp) {
  if (!serverTimestamp) {
    throw new Error('Missing serverTimestamp function');
  }
  return new Traveler(traveler).toFirestore({ serverTimestamp });
}

/** True when the traveler's final step has been marked Passed. */
function travelerLastStepPassed(steps = []) {
  if (!steps?.length) return false;
  return steps[steps.length - 1]?.inspected === InspectionValues.PASSED;
}

export {
  travelerFromFirestore,
  travelerLastStepPassed,
  travelerToFirestore,
};
